/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Select_List_LeftInputs */

const en_select_list_left = /** @type {(inputs: Select_List_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please select a list from the menu on the left`)
};

const fr_select_list_left = /** @type {(inputs: Select_List_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez sélectionner une liste dans le menu de gauche`)
};

const de_select_list_left = /** @type {(inputs: Select_List_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte wählen Sie eine Liste aus dem Menü links aus.`)
};

const it_select_list_left = /** @type {(inputs: Select_List_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona un elenco dal menu a sinistra`)
};

const ru_select_list_left = /** @type {(inputs: Select_List_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пожалуйста, выберите список из меню слева.`)
};

const es_select_list_left = /** @type {(inputs: Select_List_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor seleccione una lista del menú de la izquierda`)
};

const zh_cn2_select_list_left = /** @type {(inputs: Select_List_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请从左侧菜单中选择一个列表。`)
};

const ja_select_list_left = /** @type {(inputs: Select_List_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`左側のメニューからリストを選択してください`)
};

const hi_select_list_left = /** @type {(inputs: Select_List_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कृपया बाईं ओर दिए गए मेनू से एक सूची चुनें।`)
};

const pt_pt2_select_list_left = /** @type {(inputs: Select_List_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione uma lista no menu à esquerda.`)
};

/**
* | output |
* | --- |
* | "Please select a list from the menu on the left" |
*
* @param {Select_List_LeftInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const select_list_left = /** @type {((inputs?: Select_List_LeftInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Select_List_LeftInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_select_list_left(inputs)
	if (locale === "de") return de_select_list_left(inputs)
	if (locale === "it") return it_select_list_left(inputs)
	if (locale === "ru") return ru_select_list_left(inputs)
	if (locale === "es") return es_select_list_left(inputs)
	if (locale === "zh-CN") return zh_cn2_select_list_left(inputs)
	if (locale === "ja") return ja_select_list_left(inputs)
	if (locale === "hi") return hi_select_list_left(inputs)
	if (locale === "pt-PT") return pt_pt2_select_list_left(inputs)
	return en_select_list_left(inputs)
});